import CookiePopup from './CookiePopup.vue';
import WhatsappPopup from './WhatsappPopup.vue';
import WarningPopup from './WarningPopup.vue';
import OptinPopup from './OptinPopup.vue';
import BannerPopup from './BannerPopup.vue';
import CountdownPopup from './CountdownPopup.vue';

export default {
  CookiePopup,
  WhatsappPopup,
  WarningPopup,
  OptinPopup,
  BannerPopup,
  CountdownPopup,
};
